import React from "react";
import "./privacy.css";

export const Privacy = () => {
  return (
    <div className="priv-hub-wrapper">
      <div className="priv-hub-container">
        {/* Header Block Section */}
        <div className="priv-header-block">
          <h1 className="priv-main-title">Privacy Policy</h1>
          <p className="priv-main-subtitle">
            Transparent breakdown of data protocols, user security, and storage
            architecture.
          </p>
        </div>

        {/* Unified Glass Policy Document Wrapper */}
        <div className="priv-document-card">
          <div className="priv-text-engine">
            <p>
              This Privacy Policy outlines how we collect, use, and disclose
              personal information when you visit and use our website. We are
              committed to protecting your privacy and safeguarding your
              personal information. Please review this policy carefully to
              understand our practices regarding your personal information and
              how we handle it.
            </p>

            {/* Inline typography locked to bypass global CSS contamination */}
            <h3
              style={{
                fontSize: "2.4rem",
                fontWeight: 700,
                color: "#ffffff",
                marginTop: "40px",
                marginBottom: "16px",
                borderBottom: "1px solid rgba(255,255,255,0.08)",
                paddingBottom: "8px",
              }}
            >
              1. Information We Collect
            </h3>

            <h4
              style={{
                fontSize: "1.8rem",
                fontWeight: 600,
                color: "#ffffff",
                marginTop: "24px",
                marginBottom: "8px",
              }}
            >
              1.1 Personal Information
            </h4>
            <p>
              When you visit our website and voluntarily provide us with
              personal details, such as your name, email address, phone number,
              and other contact information, we collect and store this data.
              Additionally, we may gather any other information you choose to
              provide, including preferences, budget, and other relevant
              details.
            </p>

            <h4
              style={{
                fontSize: "1.8rem",
                fontWeight: 600,
                color: "#ffffff",
                marginTop: "24px",
                marginBottom: "8px",
              }}
            >
              1.2 Usage Information
            </h4>
            <p>
              We may automatically collect non-personal information when you use
              our website, including your IP address, browser type, operating
              system, and the pages you visit. This information helps us improve
              our website and enhance your user experience.
            </p>

            <h4
              style={{
                fontSize: "1.8rem",
                fontWeight: 600,
                color: "#ffffff",
                marginTop: "24px",
                marginBottom: "8px",
              }}
            >
              1.3 Cookies and Tracking Technologies
            </h4>
            <p>
              We use cookies and similar tracking technologies to personalize
              your browsing experience, analyze traffic, and improve website
              functionality. You can disable cookies through your browser
              settings, but some features of the website may not work properly
              as a result.
            </p>

            <h3
              style={{
                fontSize: "2.4rem",
                fontWeight: 700,
                color: "#ffffff",
                marginTop: "40px",
                marginBottom: "16px",
                borderBottom: "1px solid rgba(255,255,255,0.08)",
                paddingBottom: "8px",
              }}
            >
              2. Use of Personal Information
            </h3>

            <h4
              style={{
                fontSize: "1.8rem",
                fontWeight: 600,
                color: "#ffffff",
                marginTop: "24px",
                marginBottom: "8px",
              }}
            >
              2.1 Providing Services
            </h4>
            <p>
              We use your personal information to deliver the services you
              request, such as contacting you with property listings, responding
              to inquiries, and facilitating communication between you and
              potential buyers or sellers.
            </p>

            <h4
              style={{
                fontSize: "1.8rem",
                fontWeight: 600,
                color: "#ffffff",
                marginTop: "24px",
                marginBottom: "8px",
              }}
            >
              2.2 Website Improvement
            </h4>
            <p>
              Your information may be used to enhance our website, develop new
              features, conduct market research, and improve the overall user
              experience.
            </p>

            <h4
              style={{
                fontSize: "1.8rem",
                fontWeight: 600,
                color: "#ffffff",
                marginTop: "24px",
                marginBottom: "8px",
              }}
            >
              2.3 Marketing Communications
            </h4>
            <p>
              With your consent, we may send you marketing communications about
              our services, special offers, or other relevant information via
              email, SMS/text messages, or other communication channels. You can
              opt out of these communications at any time by following the
              unsubscribe instructions provided in the message or by contacting
              us directly.
            </p>

            <h4
              style={{
                fontSize: "1.8rem",
                fontWeight: 600,
                color: "#ffffff",
                marginTop: "24px",
                marginBottom: "8px",
              }}
            >
              2.4 Legal Compliance
            </h4>
            <p>
              We may use or disclose your personal information if required to do
              so by law, regulation, legal process, or government request, or to
              protect our rights, property, or safety, as well as the rights,
              property, or safety of others.
            </p>

            <h3
              style={{
                fontSize: "2.4rem",
                fontWeight: 700,
                color: "#ffffff",
                marginTop: "40px",
                marginBottom: "16px",
                borderBottom: "1px solid rgba(255,255,255,0.08)",
                paddingBottom: "8px",
              }}
            >
              3. Data Sharing
            </h3>

            <h4
              style={{
                fontSize: "1.8rem",
                fontWeight: 600,
                color: "#ffffff",
                marginTop: "24px",
                marginBottom: "8px",
              }}
            >
              3.1 Service Providers
            </h4>
            <p>
              We do not share your personal information with third-party
              providers.
            </p>

            <h4
              style={{
                fontSize: "1.8rem",
                fontWeight: 600,
                color: "#ffffff",
                marginTop: "24px",
                marginBottom: "8px",
              }}
            >
              3.2 Privacy Choices
            </h4>
            <p>
              We respect your privacy preferences and will not share your
              personal information with third parties for marketing or
              promotional purposes without your consent.
            </p>

            <h4
              style={{
                fontSize: "1.8rem",
                fontWeight: 600,
                color: "#ffffff",
                marginTop: "24px",
                marginBottom: "8px",
              }}
            >
              3.3 Legal Obligations
            </h4>
            <p>
              We may disclose your personal information to comply with legal
              obligations, enforce our terms of service, or protect our rights,
              property, or safety.
            </p>

            <h3
              style={{
                fontSize: "2.4rem",
                fontWeight: 700,
                color: "#ffffff",
                marginTop: "40px",
                marginBottom: "16px",
                borderBottom: "1px solid rgba(255,255,255,0.08)",
                paddingBottom: "8px",
              }}
            >
              4. Data Security
            </h3>
            <p>
              We implement reasonable measures to protect your personal
              information from unauthorized access, use, or disclosure. However,
              no method of transmission over the internet or electronic storage
              is 100% secure, and we cannot guarantee absolute security.
            </p>

            <h3
              style={{
                fontSize: "2.4rem",
                fontWeight: 700,
                color: "#ffffff",
                marginTop: "40px",
                marginBottom: "16px",
                borderBottom: "1px solid rgba(255,255,255,0.08)",
                paddingBottom: "8px",
              }}
            >
              5. Your Rights
            </h3>
            <p>
              You have rights regarding your personal information, including the
              ability to access, correct, or delete your data, as well as to
              restrict or object to its processing. For any privacy-related
              inquiries or to exercise these rights, please contact us using the
              information provided below.
            </p>

            <h3
              style={{
                fontSize: "2.4rem",
                fontWeight: 700,
                color: "#ffffff",
                marginTop: "40px",
                marginBottom: "16px",
                borderBottom: "1px solid rgba(255,255,255,0.08)",
                paddingBottom: "8px",
              }}
            >
              6. Children’s Privacy
            </h3>
            <p>
              Our website is not intended for individuals under the age of 18.
              We do not knowingly collect personal information from children. If
              we discover that we have collected personal information from a
              child without appropriate parental consent, we will take steps to
              delete it.
            </p>

            <h3
              style={{
                fontSize: "2.4rem",
                fontWeight: 700,
                color: "#ffffff",
                marginTop: "40px",
                marginBottom: "16px",
                borderBottom: "1px solid rgba(255,255,255,0.08)",
                paddingBottom: "8px",
              }}
            >
              7. Changes to This Privacy Policy
            </h3>
            <p>
              We may update this Privacy Policy periodically to reflect changes
              in our practices or applicable laws. We will notify you of any
              material changes by posting the updated policy on our website and
              indicating the effective date.
            </p>

            <p>
              We encourage you to review this policy regularly to stay informed
              about how we handle your personal information. We are committed to
              addressing your inquiries and resolving any concerns in a timely
              manner.
            </p>

            <p
              style={{ fontWeight: "600", color: "#ffffff", marginTop: "32px" }}
            >
              By using our website, you acknowledge that you have read and
              understood this Privacy Policy and agree to the collection, use,
              and disclosure of your personal information as described.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
